import { Shape } from '@/components/icons/Shape'
import cn from 'classnames'
import ReactSlider, { ReactSliderProps } from 'react-slider'

const Slider: React.FC<any> = ReactSlider as unknown as any

export const RangeSlider = <T extends number | readonly number[]>(
  props: ReactSliderProps<T> & { hiddenValue?: boolean; isArrayValue?: boolean; minLabel?: any; maxLabel?: any }
) => {
  const isVertical = props.orientation === 'vertical'
  const hiddenValue = props.hiddenValue
  const isArrayValue = props.isArrayValue

  return (
    <Slider
      {...props}
      renderThumb={(thumbProps: any, state: any) => {
        let label = state.valueNow
        if (props.min === state.valueNow && props.minLabel !== undefined) {
          label = props.minLabel
        } else if (props.max === state.valueNow && props.maxLabel !== undefined) {
          label = props.maxLabel
        }

        return (
          <div
            {...thumbProps}
            className={cn({
              'h-full': !isVertical,
              'w-full': isVertical,
              'aspect-square rounded-full bg-primary-300 text-xs text-white flex items-center justify-center cursor-grab':
                true,
            })}
          >
            {!hiddenValue && (
              <div className={`absolute z-10 -top-[42px] flex justify-center items-center`}>
                <Shape className="text-primary-300" />
                <span className="absolute text-white text-xs font-medium pb-1">{label}</span>
              </div>
            )}
          </div>
        )
      }}
      renderTrack={(trackProps: any, state: any) => {
        const { index } = state
        return (
          <div
            {...trackProps}
            className={cn({
              'h-1/4 top-1/2 -translate-y-1/2': !isVertical,
              'w-1/4 left-1/2 -translate-x-1/2': isVertical,
              'rounded-full bg-white bg-opacity-50': isArrayValue ? index !== 1 : index === 1,
              'rounded-full bg-primary-300': isArrayValue ? index === 1 : index !== 1,
            })}
          ></div>
        )
      }}
    />
  )
}
